import { storage } from './storage';

export const routes = {
  DEFAULT: '/',
  MAIN: '/main',
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  FORGOT_ID: '/forgot-id',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_CODE: '/verify-code',
  VERIFY_ACCOUNT: '/verify-account',
  RESET_PASSWORD: '/reset-password',
  PROJECT: '/project',
  CHECK_REWARD: '/check-reward',
  REWARD_EXCHANGE: '/reward-exchange',
  MY_PAGE: '/my-page',
  CHECK_PASSWORD: '/check-password',
  PROCEED_TASK: '/proceed-task/:project/:limit?',
  SOCIAL_EDITOR: '/social-editor',
  PROJECT_MANAGEMENT: '/project-management',
  REWARD_MANAGEMENT: '/reward-management',
  USER_EXCHANGE_MANAGEMENT: '/user-exchange-management',
  REWARD_ITEM_MANAGEMENT: '/reward-item-management',
  UPDATE_PROJECT: '/project-management/:id',
  CREATE_PROJECT: '/create-project',
  TASK_REVIEW: '/task-review/:project',
  CREATE_CATEGORY: '/create-category',
  USER_MANAGEMENT: '/user-management',
  UPDATE_USER: '/user-management/:id',
  GROUP_MANAGEMENT: '/group-management',
  CREATE_USER: '/create-user',
  CREATE_REWARD_ITEM: '/reward-item-management/create',
  UPDATE_REWARD_ITEM: '/reward-item-management/:id',
  CREATE_REWARD: '/create-reward',
  UPDATE_REWARD: '/reward-management/:id',
  GT_MANAGEMENT: '/gt-management',
  PROCEED_GT: '/proceed-gt/:project',
  PROJECT_ANALYTICS: '/project-analytics',
  REVIEW_DASHBOARD: '/review-dashboard',
  REVIEW_VIEWER: '/review-viewer/:annotationId?',
  // 꿈챗
  DREAM_CHAT: '/dream-chat',
  DREAM_CHAT_DETAIL: '/dream-chat/:chatId',
  /** 공개 이미지 갤러리 슬롯 1~10 또는 네임드(dsu) */
  uploaderPath: (n: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 'dsu') =>
    n === 'dsu' ? '/uploader_dsu' : `/uploader${n}`,
  // 커뮤니티 라우트 추가
  COMMUNITY: '/community',
  COMMUNITY_POST: '/community/:id',
  COMMUNITY_WRITE: '/community/write',
  COMMUNITY_EDIT: '/community/edit/:id',
};

export interface RouteGuard {
  /**
   * If the condition is not met then either redirect to onFail or don't render the route
   */
  failCondition: boolean;
  /**
   * If request is still in progress we don't want to call onFail yet
   */
  requestDone: boolean;
  /**
   * URL where to redirect to, when condition is not met
   */
  onFail?: string | null;
}

export const unAuthGuard: RouteGuard = {
  failCondition: !!storage.getToken(),
  requestDone: true,
  onFail: routes.DEFAULT,
};

export const authGuard: RouteGuard = {
  failCondition: !storage.getToken(),
  requestDone: true,
  onFail: routes.DEFAULT,
};

// 선택적 인증 가드 - 항상 통과 (읽기 전용 페이지용)
export const optionalAuthGuard: RouteGuard = {
  failCondition: false,  // 항상 통과
  requestDone: true,
  onFail: null,
};

// 로그인 유도 가드 - 로그인 안되어 있으면 로그인 페이지로
export const loginPromptGuard: RouteGuard = {
  failCondition: !storage.getToken(),
  requestDone: true,
  onFail: routes.LOGIN,  // 로그인 페이지로 리다이렉트
};